import { TraitRegistryCategory } from '../TraitRegistryCategory';
import { TraitTypeSwitchButtons } from '../traitTypes/TraitTypeSwitchButtons';
import { TraitTypeSelectWithPreview } from '../traitTypes/TraitTypeSelectWithPreview';
import { TraitTypeNumericWithSlider } from '../traitTypes/TraitTypeNumericWithSlider';
export class TraitRegistryMediaVideo extends TraitRegistryCategory {
    label = 'Video';
    constructor(parent) {
        super(parent);
        super.init();
    }
    videoControls = () => new TraitTypeSwitchButtons({
        select: [
            [0, 'nein'],
            [1, 'ja'],
        ],
        default: 1,
    });
    videoRatio = () => new TraitTypeSelectWithPreview({
        select: [['none'], ['stretch']],
        classNames: ({ at }) => {
            if (at.trait.value === 'stretch')
                return ['stretchVideo'];
        },
    });
    playOnReady = () => new TraitTypeSwitchButtons({
        select: [
            [0, 'nein'],
            [1, 'completly loaded'],
            [2, 'immediate'],
        ],
    });
    videoLoop = () => new TraitTypeSwitchButtons({
        default: false,
        select: [
            [true, 'ja'],
            [false, 'nein'],
        ],
    });
    videoStopMark = () => new TraitTypeNumericWithSlider({
        min: 0,
        max: 30000,
        multiple: true,
        onEditChange: at => {
            at.context.app.stage.stageMountedActors.mountedActors
                .filter(a => a.type === 'video')
                .map((v) => v.reactPlayer)
                .filter(p => !!p)
                .forEach(p => {
                p.seekTo(at.trait.value / 1000, 'seconds');
            });
        },
    });
}
